define [], () ->
  name: 'dashboard', url: '^/dashboard/'
  template: require("./dashboard.jade")
  controller: require("./dashboard.coffee")
  children: [
    name: 'applications', url: 'applications/'
    controller: require('./applications/applications.coffee')
    template: require('./applications/applications.jade')
    resolve:
      activeApplications: (ApplicationBundle) ->
        ApplicationBundle.query
          limit: 25
          offset: 0
          applications__is_removed: false
          applications__is_archived: false
          for_datatable: true
        .$promise.then (appbundles) ->
            return appbundles
      archivedApplications: (ApplicationBundle) ->
        ApplicationBundle.query
          limit: 25
          offset: 0
          applications__is_removed: false
          applications__is_archived: true
          for_datatable: true
        .$promise.then (appbundles) ->
            return appbundles
  ,
    name: 'applicant_applications', url: 'applications/applicant'
    controller: require('./applicant/applicant.coffee')
    template: require('./applicant/applicant.jade')
    resolve:
      applications: (RentappService, ApplicationBundle) ->
        RentappService.getMe().then (user) ->
          ApplicationBundle.query
            limit: 25
            offset: 0
            applications__applicant__user__username: user.username
            for_datatable: true
          .$promise.then (appbundles) ->
            return appbundles
  ,
    name: 'forms', url: 'forms/'
    controller: require('./forms/forms.coffee')
    template: require('./forms/forms.jade')
    params:
      reload: false
      quick_form: null
    resolve:
      rowCollection: (ApplicationTemplate, RentappService) ->
        ApplicationTemplate.query()
          .$promise.then (apptemplates) ->
            return apptemplates
  ,
    name: 'payments',
    url: 'payments/'
    template: require('./payments/payments.jade')
    controller: require('./payments/payments.coffee')
    children: [
      name: 'accounts', url: 'accounts/'
      controller: require('./payments/accounts/accounts.coffee')
      template: require('./payments/accounts/accounts.jade')
    ,
      name: 'not_enabled', url: 'not_enabled/'
      template: require('./payments/help/help.jade')
      resolve:
        show_buttons: () -> true
      controller: require('./payments/help/help.coffee')
    ,
      name: 'help', url: 'help/'
      template: require('./payments/help/help.jade')
      resolve:
        show_buttons: () -> false
      controller: require('./payments/help/help.coffee')
    ,
      name: 'bank_account_info', url: 'bank_account_info/'
      template: require('./payments/signup/bank_account_info/bank_account_info.jade')
      controller: require('./payments/signup/bank_account_info/bank_account_info.coffee')
      params:
        errors: null
        account: null
        account_settings: null
    ,
      name: 'payment_info', url: 'payment_info/'
      template: require('./payments/signup/payment_info/payment_info.jade')
      controller: require('./payments/signup/payment_info/payment_info.coffee')
      params:
        account: null
        account_settings: null
    , # success url is placed on body making conflicts
      name: 'confirm', url: 'confirm/'
      template: require('./payments/signup/success/success.jade')
      controller: require('./payments/signup/success/success.coffee')
    ]
  ,
    name: 'settings', url: 'settings/'
    template: require('./settings/settings.jade')
    controller: require('./settings/settings.coffee')
    children: [
      name: 'profile', url: 'profile/'
      controller: require('./settings/profile/profile.coffee')
      template: require('./settings/profile/profile.jade')
      resolve:
        landlord: (Landlord) ->
          Landlord.getMe().$promise.then (response) ->
            return response
    ,
      name: 'notifications', url: 'notifications/'
      controller: require('./settings/notifications/notifications.coffee')
      template: require('./settings/notifications/notifications.jade')
    ,
      name: 'password', url: 'password/'
      template: require('./settings/password/password.jade')
    ,
      name: 'bank_account', url: 'bank_account/'
      controller: require('./settings/bank_account/bank_account.coffee')
      template: require('./settings/bank_account/bank_account.jade')
    ,
      name: 'company', url: 'company/'
      controller: require('./settings/company/company.coffee')
      template: require('./settings/company/company.jade')
    ]
  ,
    name: 'view_application', url: 'view/{application_id}/{shareToken}/'
    params:
      shareToken: {squash: true, value: null}
    public: true
    controller: require("./view/view.coffee")
    template: require("./view/view.jade")
    children: [
      name: 'application'
      controller: require('./view/application/application.coffee')
      template: require('./view/application/application.jade')
      params:
        application: null
    ,
      name: 'reports'
      controller: require('./view/reports/reports.coffee')
      template: require('./view/reports/reports.jade')
      params:
        application: null
        profile: null
    ]
  ,
    name: 'quick_forms_display', url: '^/quick_forms_display/'
    controller: require("./quick_forms/quick_forms_display.coffee")
    template: require("./quick_forms/quick_forms_display.jade")
  ,
    name: 'notifications', url: '^/notifications/'
    controller: require("./notifications/notifications.coffee")
    template: require("./notifications/notifications.jade")
    resolve:
      notifications: (RENTAPPLICATION_API_URL, $http) ->
        $http.get "#{RENTAPPLICATION_API_URL}/api/v1/notification/"
        .then (notifications) ->
          return notifications.data
  ,
    name: 'referral', url: 'referral/'
    controller: require("./referral/referral.coffee")
    template: require("./referral/referral.jade")
    resolve:
      affiliate_referrer: (RENTAPPLICATION_API_URL, $http) ->
        $http.get "#{RENTAPPLICATION_API_URL}/api/v3/referrers/"
        .then (resp) ->
          return resp.data.results[0]
  ]



// WEBPACK FOOTER //
// ./components/dashboard/routes.coffee